import { CareAppListActionFactory } from "./action-factory";
import {
  CustomerRequestInterface,
  CustomerResponseInterface,
  FileRecord
} from "@careapp/angular-sdk";

export class CustomerActionFactory extends CareAppListActionFactory<
  CustomerResponseInterface
> {
  get REQUEST_ADD_CUSTOMER_FILE() {
    return `[${this.type}][Request] Add Customer File`;
  }
  get RESPONSE_SUCCESS_ADD_CUSTOMER_FILE() {
    return `[${this.type}][Response][Success] Add Customer File`;
  }
  get RESPONSE_FAIL_ADD_CUSTOMER_FILE() {
    return `[${this.type}][Response][Fail] Add Customer File`;
  }

  get REQUEST_BULK_ADD_CUSTOMERS() {
    return `[${this.type}][Request] Bulk Add Customers`;
  }
  get PROGRESS_BULK_ADD_CUSTOMERS() {
    return `[${this.type}][Progress] Bulk Add Customers`;
  }
  get RESPONSE_SUCCESS_BULK_ADD_CUSTOMERS() {
    return `[${this.type}][Response][Success] Bulk Add Customers`;
  }
  get RESPONSE_FAIL_BULK_ADD_CUSTOMERS() {
    return `[${this.type}][Response][Fail] Bulk Add Customers`;
  }

  RequestAddCustomerFile(payload: { id: string }) {
    return {
      type: this.REQUEST_ADD_CUSTOMER_FILE,
      payload
    };
  }

  ResponseSuccessAddCustomerFile(payload: FileRecord) {
    return {
      type: this.RESPONSE_SUCCESS_ADD_CUSTOMER_FILE,
      payload
    };
  }

  ResponseFailAddCustomerFile(payload: any) {
    return {
      type: this.RESPONSE_FAIL_ADD_CUSTOMER_FILE,
      payload
    };
  }

  RequestBulkAddCustomers(payload: CustomerRequestInterface[]) {
    return {
      type: this.REQUEST_BULK_ADD_CUSTOMERS,
      payload
    };
  }

  ProgressBulkAddCustomers(payload: number) {
    return {
      type: this.PROGRESS_BULK_ADD_CUSTOMERS,
      payload
    };
  }

  ResponseSuccessBulkAddCustomers(payload: CustomerResponseInterface[]) {
    return {
      type: this.RESPONSE_SUCCESS_BULK_ADD_CUSTOMERS,
      payload
    };
  }

  ResponseFailBulkAddCustomers(payload: any) {
    return {
      type: this.RESPONSE_FAIL_BULK_ADD_CUSTOMERS,
      payload
    };
  }

  constructor() {
    super(`Customers`);
  }
}

export const Customers = new CustomerActionFactory();
